import axios from 'axios';

// 1. Creamos la instancia de Axios
const apiClient = axios.create({
  baseURL: 'https://pc.contraloriadecarirubana.gob.ve/api/',

  headers: {
    'Content-Type': 'application/json',
  },
});

// 2. Configuramos los interceptors (la "inteligencia" de nuestro cliente API)

// --- INTERCEPTOR DE PETICIONES (YA EXISTENTE) ---
// Se ejecuta ANTES de que cada petición sea enviada.
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// --- INTERCEPTOR DE RESPUESTAS (NUEVO) ---
// Se ejecuta DESPUÉS de recibir una respuesta del servidor.
apiClient.interceptors.response.use(
  // Si la respuesta es exitosa, simplemente la devuelve.
  (response) => response,
  
  // Si la respuesta es un error...
  (error) => {
    // Verificamos si el error es un 401 Unauthorized.
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken'); // Limpiamos el token viejo.
      // Redirigimos al usuario a la página de login.
      window.location.href = '/login';
    }
    // Para cualquier otro error, simplemente lo devolvemos.
    return Promise.reject(error);
  }
);


// 3. Exportamos las funciones que usarán nuestros componentes

export const login = (username, password) => {
  return apiClient.post('/token/', { username, password });
};

export const crearSolicitud = (data) => {
  return apiClient.post('/public/', data);
};

export const consultarEstatus = (codigo) => {
  return apiClient.post('/public/consultar/', { codigo_seguimiento: codigo });
};

export const getSolicitudes = (params = {}) => {
  return apiClient.get('/management/', { params });
};

export const getSolicitudById = (id) => {
  return apiClient.get(`/management/${id}/`);
};

export const addComment = (id, texto) => {
  return apiClient.post(`/management/${id}/add_comment/`, { texto });
};

export const getGestores = () => {
  return apiClient.get('/gestores/');
};

export const updateSolicitud = (id, data) => {
  return apiClient.patch(`/management/${id}/`, data);
};

export const getStatsByStatus = () => {
  return apiClient.get('/management/stats_by_status/');
};

export const getStatsByType = () => {
  return apiClient.get('/management/stats_by_type/');
};
